import { useEffect } from 'react';

interface CallbackOnEnterProps {
  callback?: () => void | Promise<void>;
  enabled: boolean;
}

export function useCallbackOnEnter({ callback, enabled }: CallbackOnEnterProps) {
  useEffect(() => {
    if (!callback || !enabled) {
      return;
    }

    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Enter') {
        void callback();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [callback, enabled]);
}
